import USER_AUTHORITIES from '../../Auth/enums/userAuthorities';
import { AuthService } from '../../Auth/services/authServices';
import { MainMenuConfiguration } from '../interfaces/MainMenuConfiguration';
import { MainMenuItem } from '../interfaces/MainMenuItem';

export class MainMenuService {
    static rootRoutePath: string = '/';
    static usersRoutePath: string = 'user';
    static calendarRoutePath: string = 'calendar';
    static participantsRoutePath: string = 'participant';
    static employeesRoutePath: string = 'employee';
    static articlesRoutePath: string = 'article';
    static bannersRoutePath: string = 'banners';
    static itemsRoutePath: string = 'item';
    static itemsCalculatorRoutePath: string = 'items-calculator';
    static chatRoutePath: string = 'chat';
    static dictionariesRoutePath: string = 'dictionaries';
    static itemSubjectsRoutePath: string = 'item-subject';
    static articleSubjectsRoutePath: string = 'article-subject';
    static commentsRoutePath: string = 'comment';
    static vacanciesRoutePath: string = 'vacancy';
    static responsesRoutePath: string = 'response';
    static analyticsRoutePath: string = 'analytics';
    static consentAdvertisingReportRoutePath: string = 'consent-advertising-report';
    static auditRoutePath: string = 'audit';
    static subjectGroupsRoutePath: string = 'subject-group';
    static systemSettingsPath: string = 'system-settings';
    static syncLogsRoutePath: string = 'sync-logs';
    static misLogsRoutePath: string = 'mis';
    static takLogsRoutePath: string = 'tak';
    static documentsPath: string = 'document';
    static organizationsPath: string = 'organization';
    static profileSettingsPath: string = 'profile-settings';
    static specialitiesPath: string = 'specialities';
    static postsPath: string = 'post';
    static tagsPath: string = 'tag';

    static get iconBasePath(): string {
        return 'assets/images/svg/';
    }

    /**
     * Конфигурация главного меню
     */
    static get mainMenuConfiguration(): MainMenuConfiguration {
        let autoIncreasingId: number = 0;

        return {
            calendar: {
                id: ++autoIncreasingId,
                iconPath: `${MainMenuService.iconBasePath}archive.svg`,
                name: 'calendar',
                visibleName: 'Календарь',
                family: MainMenuService.calendarRoutePath,
                routePath: `/${MainMenuService.calendarRoutePath}`,
                hide: !AuthService.userHasRole(USER_AUTHORITIES.ADMIN.value),
            },
            participants: {
                id: ++autoIncreasingId,
                iconPath: `${MainMenuService.iconBasePath}archive.svg`,
                name: 'participants',
                visibleName: 'Заявки',
                family: MainMenuService.participantsRoutePath,
                routePath: `/${MainMenuService.participantsRoutePath}/list`,
                hide: !AuthService.userHasRole(USER_AUTHORITIES.ADMIN.value),
            },
            employees: {
                id: ++autoIncreasingId,
                iconPath: `${MainMenuService.iconBasePath}archive.svg`,
                name: 'employees',
                visibleName: 'Врачи',
                family: MainMenuService.employeesRoutePath,
                routePath: `/${MainMenuService.employeesRoutePath}/list`,
                hide: !AuthService.userHasOneRole([
                    USER_AUTHORITIES.ADMIN.value,
                    USER_AUTHORITIES.CONTENT_MANAGER.value,
                ]),
            },
            articles: {
                id: ++autoIncreasingId,
                iconPath: `${MainMenuService.iconBasePath}archive.svg`,
                name: 'articles',
                visibleName: 'Новости',
                family: MainMenuService.articlesRoutePath,
                notFamily: MainMenuService.articleSubjectsRoutePath,
                routePath: `/${MainMenuService.articlesRoutePath}/list`,
                hide: !AuthService.userHasOneRole([
                    USER_AUTHORITIES.ADMIN.value,
                    USER_AUTHORITIES.CONTENT_MANAGER.value,
                ]),
            },
            banners: {
                id: ++autoIncreasingId,
                iconPath: `${MainMenuService.iconBasePath}archive.svg`,
                name: 'banners',
                visibleName: 'Баннеры',
                family: MainMenuService.bannersRoutePath,
                routePath: `/${MainMenuService.bannersRoutePath}`,
                hide: !AuthService.userHasRole(USER_AUTHORITIES.ADMIN.value),
            },
            items: {
                id: ++autoIncreasingId,
                iconPath: `${MainMenuService.iconBasePath}archive.svg`,
                name: 'items',
                visibleName: 'Услуги',
                family: MainMenuService.itemsRoutePath,
                notFamily: [
                    MainMenuService.itemSubjectsRoutePath,
                    MainMenuService.itemsCalculatorRoutePath,
                ],
                routePath: `/${MainMenuService.itemsRoutePath}/list`,
                hide: !AuthService.userHasOneRole([
                    USER_AUTHORITIES.ADMIN.value,
                    USER_AUTHORITIES.CONTENT_MANAGER.value,
                ]),
            },
            itemsCalculator: {
                id: ++autoIncreasingId,
                iconPath: `${MainMenuService.iconBasePath}archive.svg`,
                name: 'items-calculator',
                visibleName: 'Калькулятор услуг',
                family: MainMenuService.itemsCalculatorRoutePath,
                routePath: `/${MainMenuService.itemsCalculatorRoutePath}`,
                hide: !AuthService.userHasOneRole([
                    USER_AUTHORITIES.ADMIN.value,
                    USER_AUTHORITIES.BOOKING_OPERATOR.value,
                ]),
            },
            users: {
                id: ++autoIncreasingId,
                iconPath: `${MainMenuService.iconBasePath}archive.svg`,
                name: 'users',
                visibleName: 'Пользователи',
                family: MainMenuService.usersRoutePath,
                routePath: `/${MainMenuService.usersRoutePath}/list`,
                hide: !AuthService.userHasRole(USER_AUTHORITIES.ADMIN.value),
            },
            chat: {
                id: ++autoIncreasingId,
                iconPath: `${MainMenuService.iconBasePath}archive.svg`,
                name: 'chat',
                visibleName: 'Чат',
                family: MainMenuService.chatRoutePath,
                routePath: `/${MainMenuService.chatRoutePath}/list`,
                hide: !AuthService.userHasOneRole([
                    USER_AUTHORITIES.ADMIN.value,
                    USER_AUTHORITIES.BOOKING_OPERATOR.value,
                ]),
            },
            vacancies: {
                id: ++autoIncreasingId,
                iconPath: `${MainMenuService.iconBasePath}archive.svg`,
                name: 'vacancies',
                visibleName: 'Вакансии',
                family: MainMenuService.vacanciesRoutePath,
                routePath: `/${MainMenuService.vacanciesRoutePath}/list`,
                hide: !AuthService.userHasOneRole([
                    USER_AUTHORITIES.ADMIN.value,
                    USER_AUTHORITIES.HR_MANAGER.value,
                ]),
            },
            responses: {
                id: ++autoIncreasingId,
                iconPath: `${MainMenuService.iconBasePath}archive.svg`,
                name: 'responses',
                visibleName: 'Отклики на вакансии',
                family: MainMenuService.responsesRoutePath,
                routePath: `/${MainMenuService.responsesRoutePath}/list`,
                hide: !AuthService.userHasOneRole([
                    USER_AUTHORITIES.ADMIN.value,
                    USER_AUTHORITIES.HR_MANAGER.value,
                ]),
            },
            dictionaries: {
                id: ++autoIncreasingId,
                iconPath: `${MainMenuService.iconBasePath}archive.svg`,
                name: 'dictionaries',
                visibleName: 'Справочники',
                family: MainMenuService.dictionariesRoutePath,
                hide: !AuthService.userHasOneRole([
                    USER_AUTHORITIES.ADMIN.value,
                    USER_AUTHORITIES.CONTENT_MANAGER.value,
                ]),
                children: [
                    {
                        iconPath: `${MainMenuService.iconBasePath}archive.svg`,
                        name: 'item-subjects',
                        visibleName: 'Категории услуг',
                        family: MainMenuService.itemSubjectsRoutePath,
                        routePath: `/${MainMenuService.itemSubjectsRoutePath}/list`,
                    },
                    {
                        iconPath: `${MainMenuService.iconBasePath}archive.svg`,
                        name: 'subject-groups',
                        visibleName: 'Группы категорий услуг',
                        family: MainMenuService.subjectGroupsRoutePath,
                        routePath: `/${MainMenuService.subjectGroupsRoutePath}/list`,
                    },
                    {
                        iconPath: `${MainMenuService.iconBasePath}archive.svg`,
                        name: 'article-subjects',
                        visibleName: 'Категории новостей',
                        family: MainMenuService.articleSubjectsRoutePath,
                        routePath: `/${MainMenuService.articleSubjectsRoutePath}/list`,
                    },
                    {
                        iconPath: `${MainMenuService.iconBasePath}archive.svg`,
                        name: 'comments',
                        visibleName: 'Комментарии',
                        family: MainMenuService.commentsRoutePath,
                        routePath: `/${MainMenuService.commentsRoutePath}/list`,
                    },
                    {
                        iconPath: `${MainMenuService.iconBasePath}archive.svg`,
                        name: 'organizations',
                        visibleName: 'Организации',
                        family: MainMenuService.organizationsPath,
                        routePath: `/${MainMenuService.organizationsPath}/list`,
                    },
                    {
                        iconPath: `${MainMenuService.iconBasePath}archive.svg`,
                        name: 'specialities',
                        visibleName: 'Специализации',
                        family: MainMenuService.specialitiesPath,
                        routePath: `/${MainMenuService.specialitiesPath}/list`,
                    },
                    {
                        iconPath: `${MainMenuService.iconBasePath}archive.svg`,
                        name: 'posts',
                        visibleName: 'Должности',
                        family: MainMenuService.postsPath,
                        routePath: `/${MainMenuService.postsPath}/list`,
                    },
                    {
                        iconPath: `${MainMenuService.iconBasePath}archive.svg`,
                        name: 'tags',
                        visibleName: 'Теги',
                        family: MainMenuService.tagsPath,
                        routePath: `/${MainMenuService.tagsPath}/list`,
                    },
                ],
            },
            analytics: {
                id: ++autoIncreasingId,
                iconPath: `${MainMenuService.iconBasePath}archive.svg`,
                name: 'analytics',
                visibleName: 'Аналитика',
                family: MainMenuService.analyticsRoutePath,
                hide: !AuthService.userHasRole(USER_AUTHORITIES.ADMIN.value),
                children: [
                    {
                        iconPath: `${MainMenuService.iconBasePath}archive.svg`,
                        name: 'consent-advertising-report',
                        visibleName: 'Отчет о согласии на рассылку',
                        family: MainMenuService.consentAdvertisingReportRoutePath,
                        routePath: `/${MainMenuService.analyticsRoutePath}/${MainMenuService.consentAdvertisingReportRoutePath}`,
                    },
                ],
            },
            audit: {
                id: ++autoIncreasingId,
                iconPath: `${MainMenuService.iconBasePath}archive.svg`,
                name: 'audit',
                visibleName: 'Аудит',
                family: MainMenuService.auditRoutePath,
                routePath: `/${MainMenuService.auditRoutePath}`,
                hide: !AuthService.userHasRole(USER_AUTHORITIES.ADMIN.value),
            },
            syncLogs: {
                id: ++autoIncreasingId,
                iconPath: `${MainMenuService.iconBasePath}archive.svg`,
                name: 'sync-logs',
                visibleName: 'Логи синхронизации',
                family: `${MainMenuService.syncLogsRoutePath}-group`,
                hide: !AuthService.userHasOneRole([
                    USER_AUTHORITIES.ADMIN.value,
                    USER_AUTHORITIES.CONTENT_MANAGER.value,
                ]),
                children: [
                    {
                        iconPath: `${MainMenuService.iconBasePath}archive.svg`,
                        name: 'mis',
                        visibleName: 'МИС',
                        family: MainMenuService.misLogsRoutePath,
                        routePath: `/${MainMenuService.syncLogsRoutePath}/mis`,
                    },
                    {
                        iconPath: `${MainMenuService.iconBasePath}archive.svg`,
                        name: 'tak',
                        visibleName: 'Система чекапов',
                        family: MainMenuService.takLogsRoutePath,
                        routePath: `/${MainMenuService.syncLogsRoutePath}/tak`,
                    },
                ],
            },
            systemSettings: {
                id: ++autoIncreasingId,
                iconPath: `${MainMenuService.iconBasePath}archive.svg`,
                name: 'system-settings',
                visibleName: 'Системные настройки',
                family: MainMenuService.systemSettingsPath,
                routePath: `/${MainMenuService.systemSettingsPath}`,
                hide: !AuthService.userHasOneRole([
                    USER_AUTHORITIES.ADMIN.value,
                    USER_AUTHORITIES.CONTENT_MANAGER.value,
                ]),
            },
            documents: {
                id: ++autoIncreasingId,
                iconPath: `${MainMenuService.iconBasePath}archive.svg`,
                name: 'documents',
                visibleName: 'Документы',
                family: MainMenuService.documentsPath,
                routePath: `/${MainMenuService.documentsPath}/list`,
                hide: !AuthService.userHasOneRole([
                    USER_AUTHORITIES.ADMIN.value,
                    USER_AUTHORITIES.CONTENT_MANAGER.value,
                ]),
            },
            profileSettings: {
                id: ++autoIncreasingId,
                iconPath: `${MainMenuService.iconBasePath}archive.svg`,
                name: 'profile-settings',
                visibleName: 'Настройки профиля',
                family: MainMenuService.profileSettingsPath,
                routePath: `/${MainMenuService.profileSettingsPath}`,
            },
        };
    }

    /**
     * Получить пункты меню
     */
    static get menuItems(): MainMenuItem[] {
        return Object.values(MainMenuService.mainMenuConfiguration);
    }
}
